import mock from "../mock"
export let roomTypesList = [
  {
    id: 1,
    active_status: true,
    name: "Deluxe Pool View Room",
    room_code : "DPV",
    min_pax : 2,
    max_pax : 4,
    associated_amenities_id : [ 2, 3, 5, 7, 9 ],        
    desc: "Lorem ipsum doler sit amith",
    room_images_path: [ "/img/rooms/dpv/DPV_0000.jpg", "/img/rooms/dpv/DPV_0001.jpg", "/img/rooms/dpv/DPV_0002.jpg", "/img/rooms/dpv/DPV_0003.jpg" ]
  },  
  {
    id: 2,
    active_status: true,
    name: "Standard Triple Room",
    room_code : "STR",
    min_pax : 2,
    max_pax : 3,
    associated_amenities_id : [ 2, 3, 5, 7, 9 ],        
    desc: "Lorem ipsum doler sit amith",
    room_images_path: [ "/img/rooms/dpv/DPV_0000.jpg", "/img/rooms/dpv/DPV_0001.jpg", "/img/rooms/dpv/DPV_0002.jpg", "/img/rooms/dpv/DPV_0003.jpg" ]
  },  
  {
    id: 3,
    active_status: true,
    name: "Deluxe Family Room",
    room_code : "DPVF",
    min_pax : 1,
    max_pax : 6,
    associated_amenities_id : [ 2, 3, 5, 7, 9 ],        
    desc: "Lorem ipsum doler sit amith",
    room_images_path: [ "/img/rooms/dpv/DPV_0000.jpg", "/img/rooms/dpv/DPV_0001.jpg", "/img/rooms/dpv/DPV_0002.jpg", "/img/rooms/dpv/DPV_0003.jpg" ]
  },  
  {
    id: 4,
    active_status: true,
    name: "Standard Room",
    room_code : "STD",
    min_pax : 1,
    max_pax : 2,
    associated_amenities_id : [ 2, 3, 5, 7, 9 ],        
    desc: "Lorem ipsum doler sit amith",
    room_images_path: [ "/img/rooms/dpv/DPV_0000.jpg", "/img/rooms/dpv/DPV_0001.jpg", "/img/rooms/dpv/DPV_0002.jpg", "/img/rooms/dpv/DPV_0003.jpg" ]
  }, 
  {
    id: 5,
    active_status: true,
    name: "Pool View Standard Room",
    room_code : "PVSTD",
    min_pax : 2,
    max_pax : 4,
    associated_amenities_id : [ 2, 3, 5, 7, 9 ],        
    desc: "Lorem ipsum doler sit amith",
    room_images_path: [ "/img/rooms/dpv/DPV_0000.jpg", "/img/rooms/dpv/DPV_0001.jpg", "/img/rooms/dpv/DPV_0002.jpg", "/img/rooms/dpv/DPV_0003.jpg" ]
  }, 
]

// GET DATA
mock.onGet("/api/roomTypesList/initial-data").reply(response => {
  return [200, roomTypesList]
})

mock.onGet("/api/roomTypesList/data").reply(response => {
  let { page, perPage } = response  
  let totalPages = Math.ceil(roomTypesList.length / perPage)
  if (page !== undefined && perPage !== undefined) {
    let calculatedPage = (page - 1) * perPage    
    let calculatedPerPage = page * perPage
    return [
      200,
      { data: roomTypesList.slice(calculatedPage, calculatedPerPage), totalPages }
    ]
  } else {
    return [
      200,
      { data: roomTypesList.slice(0, 10), totalPages: Math.ceil(roomTypesList.length / 10) }
    ]
  }
})

// UPDATE DATA
mock.onPost("/api/roomTypesList/update-data").reply(request => {
  //let data = JSON.parse(request.data).obj
  roomTypesList.map(item => {
    return item    
  })
  return [200]
})

// Add DATA
mock.onPost("/api/roomTypesList/add-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let highestId = Math.max.apply(
    Math,
    roomTypesList.map(i => i.id)
  )
  roomTypesList.unshift({
    ...data,
    id: highestId + 1,
    
  })
  return [200]
})

// DELETE DATA
mock.onPost("/api/roomTypesList/delete-data").reply(request => {
  let data = JSON.parse(request.data).obj
  let index = roomTypesList.findIndex(item => item.id === data.id)
  roomTypesList.splice(index, 1)
  return [200]
})

// DELETE SELECTED DATA
mock.onPost("/api/roomTypesList/delete-selected").reply(request => {
  let data = JSON.parse(request.data).arr
  let reducedArray
  ;[roomTypesList, data].reduce((a, b) => {
    let c = b.map(j => j.id)
    return (reducedArray = a.filter(i => !c.includes(i.id)))
  })
  roomTypesList = reducedArray
  return [200]
})
